import ApiService from "../abstracts/ApiService";

class RegularsService extends ApiService {
	buildQueryString({ roomCode, email, page, limit, exportAll } = {}) {
		const params = new URLSearchParams();

		if (roomCode) {
			params.set("roomCode", roomCode);
		}
		if (email) {
			params.set("email", email);
		}
		if (page) {
			params.set("page", String(page));
		}
		if (limit) {
			params.set("limit", String(limit));
		}
		if (exportAll) {
			params.set("export", "true");
		}

		const query = params.toString();
		return query ? `?${query}` : "";
	}

	async getRegularsList({
		roomCode = null,
		email = null,
		page = 1,
		limit = 50,
		exportAll = false,
	} = {}) {
		const response = await this.protectedRequest({
			url: `/admin/regulars-list${this.buildQueryString({
				roomCode,
				email,
				page,
				limit,
				exportAll,
			})}`,
		});

		return response;
	}
}

const instance = new RegularsService();

export default instance;
